import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Chip, Divider, Stack, Typography } from '@mui/material';
import { fmtDateTime } from '../../Utils/format';
import { formatEventMessage, getSeverityConfig } from '../../Utils/eventHelpers';

const EventTimeline = ({ events = [], maxHeight = 500 }) => {
  const { t } = useTranslation('events');

  if (!events.length) {
    return (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ py: 2, textAlign: 'center' }}
      >
        {t('table.empty', 'Sem eventos para mostrar')}
      </Typography>
    );
  }

  return (
    <Box sx={{ maxHeight, overflowY: 'auto' }}>
      <Stack divider={<Divider />}>
        {events.map((event, idx) => {
          const config = getSeverityConfig(event.severity, t);
          const IconComp = config.Icon;

          return (
            <Box key={event.id || idx} sx={{ py: 1.5, display: 'flex', gap: 1.5 }}>
              <Box sx={{ pt: 0.25, color: config.color }}>
                <IconComp fontSize="small" />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap" mb={0.5}>
                  <Chip label={event.eventType} size="small" variant="outlined" />
                  {event.eventCode > 0 && (
                    <Chip label={t('eventCode', 'Código: {{code}}', { code: event.eventCode })} size="small" />
                  )}
                </Stack>
                <Typography variant="body2">{formatEventMessage(event, t)}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {fmtDateTime(event.createdAt)}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};

EventTimeline.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  maxHeight: PropTypes.number,
};

export default EventTimeline;
